import { z } from "zod";

const USERNAME_PATTERN = /^[a-zA-Z0-9._-]{3,32}$/;

function isStrongPassword(password: string): boolean {
  return (
    password.length >= 8 &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /[0-9]/.test(password)
  );
}

const passwordFormatMessage =
  "كلمة المرور يجب أن تكون 8 أحرف على الأقل وتحتوي على حرف كبير وحرف صغير ورقم";

export const loginSchema = z.object({
  identifier: z
    .string()
    .trim()
    .min(1, { message: "اسم المستخدم أو البريد الإلكتروني مطلوب" }),
  password: z
    .string()
    .min(8, { message: "كلمة المرور يجب أن تكون 8 أحرف على الأقل" }),
});

export const verifyOtpSchema = z.object({
  otp: z
    .string()
    .trim()
    .length(6, { message: "رمز التحقق يجب أن يكون 6 أرقام" })
    .regex(/^\d{6}$/, { message: "رمز التحقق يجب أن يحتوي على أرقام فقط" }),
});

const usernameFormatMessage =
  "اسم المستخدم يجب أن يكون من 3 إلى 32 حرفاً ويحتوي على أحرف وأرقام و . _ - فقط";

export const usernameSchema = z
  .string()
  .trim()
  .min(1, { message: "اسم المستخدم مطلوب" })
  .regex(USERNAME_PATTERN, { message: usernameFormatMessage });

/** Optional on create — empty string skips validation; backend auto-generates. */
export const optionalPasswordSchema = z
  .string()
  .trim()
  .refine((v) => v === "" || isStrongPassword(v), {
    message: passwordFormatMessage,
  });

/** Optional on create — empty string skips validation; backend auto-generates. */
export const optionalUsernameSchema = z
  .string()
  .trim()
  .refine((v) => v === "" || USERNAME_PATTERN.test(v), {
    message: usernameFormatMessage,
  });
